import { ClientConfigObject, ServerConfigObject } from "app/config/interfaces";
import { chartPeriods } from "app/charts/types";
import { AssetClass } from "interfaces/enums";

/**
 * These settings are applied in production.
 *
 * Changes might lead to a painful death, so be careful.
 * https://giphy.com/gifs/indiana-jones-uA147Pq6OvgCA
 *
 */

export const clientConfig: ClientConfigObject = {
    apiURL: "https://www.t-online.de/api/finance/api-gateway",
    basePath: "https://www.t-online.de",
    urlPathPrefixStocks: "/finanzen/boerse/",
    urlPathPrefixNews: "/finanzen/news/",
    adsEnabled: true,
    consentEnabled: true,
    marketOverViewUrl: "https://www.t-online.de/finanzen/boerse/",
    financeIntroductionUrl: "https://www.t-online.de/finanzen/",
    commoditiesLandingUrl: "https://www.t-online.de/-/id_88655024",
    sharesLandingUrl: "https://www.t-online.de/finanzen/boerse/aktien/",
    fondsLandingUrl: "https://www.t-online.de/finanzen/boerse/fonds/",
    etfsLandingUrl: "https://www.t-online.de/finanzen/boerse/etf/",
    indizesLandingUrl: "https://www.t-online.de/finanzen/boerse/indizes/",
    newsUrl: "https://www.t-online.de/finanzen/news",
    defaultPeriods: {
        [AssetClass.Share]: chartPeriods.INTRADAY,
        [AssetClass.Commodity]: chartPeriods.INTRADAY,
        [AssetClass.ExchangeRate]: chartPeriods.INTRADAY,
        [AssetClass.ETF]: chartPeriods.INTRADAY,
        [AssetClass.Index]: chartPeriods.INTRADAY,
        [AssetClass.Fund]: chartPeriods.THREE_YEARS
    }
};

export const serverConfig: ServerConfigObject = {
    apiURL: "https://nav811yefk.execute-api.eu-central-1.amazonaws.com/live",
    widgetHost: "www.t-online.de"
};
